module.exports = __webpack_public_path__ + "static/Ice.ca9a0806.png";